import React, { useEffect, useContext}from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from "@material-ui/core/FormHelperText";
import ImageUpload from "beaktShared/components/CustomUpload/ImageUpload.js";
import MaskedInput from 'react-text-mask';

// icons
import Store from "@material-ui/icons/Store";
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";
import { SessionContext } from "beaktShared/services/session";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { UseGetApiSimple, UsePutApi, UseGetApiendPointDiferent } from "beaktShared/services/crudeApiService";
const useStyles = makeStyles(styles);

function maskCEP(props) {
  const { inputRef, ...other } = props;    
  return (
      <MaskedInput 
      {...other}
      ref={ref => { inputRef(ref ? ref.inputElement : null); }}
      mask={[ /[0-9]/, /\d/, /\d/,/\d/,/\d/, '-', /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      />
  );
}

export default function Estabelecimento() {
  const { t } = useTranslation();
  
  const session = useContext(SessionContext);
  
  const { register, handleSubmit, setError, setValue, errors, clearError, getValues } = useForm({mode: "onBlur"});
     
  const [loading, setLoading] = React.useState(false);

  const [notification, setNotification] = React.useState(false);
  const [estabelecimentoupdate, setestabelecimentoupdate] = React.useState({});
  const [colorNotification, setColorNotification] = React.useState('info');
  const [mensagemNotification, setMensagemNotification] = React.useState(false);
  const showNotification = (mensagem,color) => {
      setMensagemNotification(mensagem);
      setColorNotification(color);
      setNotification(true);
      setTimeout(function() {
          setNotification(false);
      }, 6000);
  };

  useEffect(() => {
    LoadDadosEstabelecimento(); 
  // eslint-disable-next-line
  }, []);

  const LoadDadosEstabelecimento = () => {
    const endPoint = 'estabelecimentos/'+session.estabelecimentoId;
    UseGetApiSimple(endPoint).then(result=>{
      if(result.status !== 200)
      {
        showNotification(result.message,'danger');
        return false;
      }

      let item = result.data;
      setestabelecimentoupdate(result.data);     
      setValue('id', item.estabelecimentoId);   
      setValue('usuarioId', item.usuarioId);
      setValue('descricao', item.descricao);
      setValue('razaoSocial', item.razaoSocial);
      setValue('cnpj', item.cnpjcpf);
      setValue('email', item.email);
      setValue('telefone', item.telefone);
      setValue('celular', item.celular);
      setValue('linkFacebook', item.linkFacebook);
      setValue('linkInstagram', item.linkInstagram);
      setValue('linkTwitter', item.linkTwitter);
      setValue('cep', item.cep);
      setValue('rua', item.rua);
      setValue('numero', item.numero);
      setValue('complemento', item.complemento);
      setValue('bairro', item.bairro);
      setValue('cidade', item.cidade);
      setValue('uf', item.uf);
      return true;
    });
  }

  const [loadingValidateEmail, setloadingValidateEmail] = React.useState(false);
  const [validateEmail, setvalidateEmail] = React.useState(false);
  const handleEmailChange = e =>{
    let email = e.target.value;
    if (email==="")
        return;

    let data = getValues()
        
    setloadingValidateEmail(true);
    const endPoint = "usuarios/vefifyemail/"+email+"/"+parseInt(data.usuarioId);
    UseGetApiSimple(endPoint,0).then(result=>{
      if(result.status !== 200)
      {
          //showNotification(result.message,'danger');
          setloadingValidateEmail(false);
          return false;
      }  
      setvalidateEmail(result.data);
      if(result.data)
          setError("email", "invalidemail", t('error_message.existing_email_choose_another'))
      else
          clearError(t('label.email'));
      setloadingValidateEmail(false);
    });
  }

  const [loadingCep,setloadingCep] = React.useState(false);
    const handleCEPBlur = (e) =>{
        let cep = e.target.value; 
        if(cep==="")
            return;
        cep = cep.replace("-","");

        setloadingCep(true);
        const endPoint = "https://viacep.com.br/ws/"+cep+"/json";
        UseGetApiendPointDiferent(endPoint).then(result=>{       
            if(result.status !== 200)
            {                                     
                //showNotification(result.message,'danger');   
                setloadingCep(false); 
                return false; 
            } 
            let resultcep = result.data; 
            setValue('rua', resultcep.logradouro);
            setValue('complemento', resultcep.complemento);
            setValue('bairro', resultcep.bairro);
            setValue('cidade', resultcep.localidade);
            setValue('estado', resultcep.uf);
            setloadingCep(false);                    
        }); 
    };

  const onSubmit = (data, e) => {
    setLoading(true);    
    e.preventDefault();

    if (validateEmail) {
      setLoading(false);
      return setError("emailUsuario", "invalidemail", t('error_message.existing_email_choose_another')) 
    }

    estabelecimentoupdate.descricao = data.descricao;
    estabelecimentoupdate.razaoSocial = data.razaoSocial;
    estabelecimentoupdate.cnpjcpf = data.cnpj;
    estabelecimentoupdate.email = data.email;
    estabelecimentoupdate.telefone = data.telefone;
    estabelecimentoupdate.celular = data.celular;
    estabelecimentoupdate.linkFacebook = data.linkFacebook;
    estabelecimentoupdate.linkInstagram = data.linkInstagram;
    estabelecimentoupdate.linkTwitter = data.linkTwitter;
    estabelecimentoupdate.cep = data.cep;
    estabelecimentoupdate.rua = data.rua;
    estabelecimentoupdate.numero = data.numero;
    estabelecimentoupdate.complemento = data.complemento;
    estabelecimentoupdate.bairro = data.bairro;
    estabelecimentoupdate.cidade = data.cidade;
    estabelecimentoupdate.uf = data.uf;
    
    let endPoint = 'estabelecimentos/';
    UsePutApi(endPoint, data.id, estabelecimentoupdate).then(result=>{ 
      //console.log(result)     
      if(result.status !== 200)
      {
          showNotification(result.message,'danger');
          return false;
      }
  
      setLoading(false);
      showNotification(result.message,'success');
      return true;
    });
  };

 
  const classes = useStyles();
  return (
    <div className="maxContent">  
      <form onSubmit={handleSubmit(onSubmit)}>
        <Snackbar
            place="tr"
            color={colorNotification}
            message={mensagemNotification}
            open={notification}
            closeNotification={() => setNotification(false)}
            close
        />
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Store />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {t('label.establishment_details')}
              <input className={classes.hidden} name="id" ref={register} />
              <input className={classes.hidden} name="usuarioId" ref={register} />
            </h4>
          </CardHeader>
          <CardBody>
              
          <GridContainer>
            <GridItem xs={12} sm={12} md={9}>
         
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                        error={errors.descricao?true:false}
                        label={t('label.description')}
                        variant="outlined"
                        inputRef={register({required: true})}
                        name="descricao"
                        InputLabelProps={{shrink: true}}
                    />
                    <FormHelperText className={classes.labelRootError}>
                        {errors.descricao && <span>{t('label.required')} </span>}
                    </FormHelperText>
                  </FormControl>
                </GridItem>
              </GridContainer>
              <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                        error={errors.razaoSocial?true:false}
                        label={t('accreditation.social_reason')}
                        variant="outlined"
                        inputRef={register({required: true})}
                        name="razaoSocial"
                        InputLabelProps={{shrink: true}}
                    />
                    <FormHelperText className={classes.labelRootError}>
                        {errors.razaoSocial && <span>{t('label.required')} </span>}
                    </FormHelperText>
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                        error={errors.cnpj?true:false}
                        label={t('label.cnpj')+" / "+t('label.cpf')}
                        variant="outlined"
                        disabled={true}
                        inputRef={register({required: false})}
                        name="cnpj"
                        InputLabelProps={{shrink: true}}
                    />
                  </FormControl>
                </GridItem>
                
              </GridContainer>

            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <p>Logo </p>
              <ImageUpload
                addButtonProps={{
                  color: "primary",
                  round: true
                }}
                changeButtonProps={{
                  color: "primary",
                  round: true
                }}
                removeButtonProps={{
                  color: "danger",
                  round: true
                }}
              />
            </GridItem>   
            
          </GridContainer>

          </CardBody>
        </Card>

        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Store />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {t('label.contact_data')}
            </h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                        error={errors.email?true:false}
                        label={t('label.email')}
                        variant="outlined"
                        onBlur={handleEmailChange}
                        inputRef={register({
                          required: t('label.required'),
                          pattern: {
                            value: /^\S+@\S+$/i,
                            message: t('label.invalid_email')
                          }
                        })}
                        name="email"
                        InputLabelProps={{shrink: true}}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {loadingValidateEmail && <LoadingIcon className="rotate" />}
                            </InputAdornment>
                          ),
                        }}
                    />
                    <FormHelperText className={classes.labelRootError}>
                        {errors.email && <span>{t('label.required')} </span>}
                    </FormHelperText>
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={3}>
                  <FormControl fullWidth className={classes.formControl}>
                  <TextField
                      error={errors.telefone?true:false}
                      label={t('label.telephone')}
                      variant="outlined"
                      inputRef={register({required: false})}
                      name="telefone"
                      InputLabelProps={{shrink: true}}
                      InputProps={{
                          inputComponent: MaskCel,
                      }} 
                  />
                  </FormControl>
              </GridItem> 
              <GridItem xs={12} sm={6} md={3}>
                    <FormControl fullWidth className={classes.formControl}>
                    <TextField
                        error={errors.celular?true:false}
                        label={t('label.cell_phone')}
                        variant="outlined"
                        inputRef={register({required: false})}
                        name="celular"
                        InputLabelProps={{shrink: true}}
                        InputProps={{
                            inputComponent: MaskCel,
                        }} 
                    />
                    </FormControl>
                </GridItem> 
                <GridItem xs={12} sm={6} md={4}>
                <FormControl fullWidth className={classes.formControl}>
                <TextField
                    error={errors.linkFacebook?true:false}
                    label={t('label.facebook')}
                    variant="outlined"
                    inputRef={register({required: false})}
                    name="linkFacebook"
                    InputLabelProps={{shrink: true}}
                    inputProps={{maxLength: 50}}
                />
                </FormControl>
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                <FormControl fullWidth className={classes.formControl}>
                <TextField
                    error={errors.linkInstagram?true:false}
                    label={t('label.instagram')}
                    variant="outlined"
                    inputRef={register({required: false})}
                    name="linkInstagram"
                    InputLabelProps={{shrink: true}}
                    inputProps={{maxLength: 50}}
                />
                </FormControl>
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                <FormControl fullWidth className={classes.formControl}>
                <TextField
                    error={errors.linkTwitter?true:false}
                    label={t('label.twitter')}
                    variant="outlined"
                    inputRef={register({required: false})}
                    name="linkTwitter"
                    InputLabelProps={{shrink: true}}
                    inputProps={{maxLength: 50}}
                />
                </FormControl>
            </GridItem>
            </GridContainer>
          </CardBody>
        </Card>

        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Store />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {t('label.address_data')}
              <input className={classes.hidden} name="id" ref={register} />
            </h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
            <GridItem xs={12} sm={6} md={3}>
                  <FormControl fullWidth className={classes.formControl}>
                  <TextField
                      error={errors.cep?true:false}
                      label={t('label.zip_code')}
                      variant="outlined"
                      inputRef={register({required: false})}
                      name="cep"
                      InputLabelProps={{shrink: true}}
                      inputProps={{maxLength: 10}}
                      onBlur={handleCEPBlur}
                      InputProps={{
                          inputComponent: maskCEP,
                          endAdornment: (
                          <InputAdornment position="end">
                              {loadingCep && <LoadingIcon className="rotate" />}
                          </InputAdornment>
                          ),
                      }} 
                  />
                  </FormControl>
              </GridItem>
            <GridItem xs={12} sm={6} md={7}>
                  <FormControl fullWidth className={classes.formControl}>
                  <TextField
                      error={errors.rua?true:false}
                      label={t('label.street')}
                      variant="outlined"
                      inputRef={register({required: false})}
                      name="rua"
                      InputLabelProps={{shrink: true}}                                   
                      inputProps={{maxLength: 50}}
                  />
                  </FormControl>
              </GridItem>
            <GridItem xs={12} sm={6} md={2}>
                  <FormControl fullWidth className={classes.formControl}>
                  <TextField
                      error={errors.numero?true:false}
                      label={t('label.number')}
                      variant="outlined"
                      inputRef={register({required: false})}
                      name="numero"
                      InputLabelProps={{shrink: true}}                                      
                      inputProps={{maxLength: 8}}
                  />
                  </FormControl>
              </GridItem>
            <GridItem xs={12} sm={6} md={3}>
                  <FormControl fullWidth className={classes.formControl}>
                  <TextField
                      error={errors.complemento?true:false}
                      label={t('label.complement')}
                      variant="outlined"
                      inputRef={register({required: false})}
                      name="complemento"
                      InputLabelProps={{shrink: true}}                                        
                      inputProps={{maxLength: 30}}
                  />
                  </FormControl>
              </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                  <FormControl fullWidth className={classes.formControl}>
                  <TextField
                      error={errors.bairro?true:false}
                      label={t('label.neighborhood')}
                      variant="outlined"
                      inputRef={register({required: false})}
                      name="bairro"
                      InputLabelProps={{shrink: true}}                                        
                      inputProps={{maxLength: 50}}
                  />
                  </FormControl>
              </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                  <FormControl fullWidth className={classes.formControl}>
                  <TextField
                      error={errors.cidade?true:false}
                      label={t('label.city')}
                      variant="outlined"
                      inputRef={register({required: false})}
                      name="cidade"
                      InputLabelProps={{shrink: true}}                                        
                      inputProps={{maxLength: 50}}
                  />
                  </FormControl>
              </GridItem>
            <GridItem xs={12} sm={6} md={1}>
                  <FormControl fullWidth className={classes.formControl}>
                  <TextField
                      error={errors.estado?true:false}
                      label={t('label.state')}
                      variant="outlined"
                      inputRef={register({required: false})}
                      name="estado"
                      InputLabelProps={{shrink: true}}
                      inputProps={{maxLength: 2}}  
                  />
                  </FormControl>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>

        <div className={classes.textCenter}>
          <Button type="submit" color="primary" className={classes.updateProfileButton}>
            {t('button.update')}
            {loading && <div> ... {t('label.loading')} </div>}
          </Button>
        </div>
      
      </form>
    </div>
  );
}

function MaskCel(props) {
  const { inputRef, ...other } = props;
  
  return (
      <MaskedInput
      {...other}
      ref={ref => {
          inputRef(ref ? ref.inputElement : null);
      }}
      mask={['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      />
  );
}